import { TALL } from '@/constants/heightMappingTableValues';

export const getDefaultState = () => {
  return {
    activeTags: {
    },
    selectedViewId: null,
    selectedRowHeight: TALL,
    views: [],
    viewOrder: [],
  };
};
export const state = getDefaultState();
